import React from "react";
import {
  Container,
  Grid,
  Typography,
  Button,
  TextField as MuiTextField,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { Formik } from "formik";
import * as Yup from "yup";
import styled from "styled-components";
import { spacing } from "@mui/system";
import { useNavigate } from "react-router-dom";

const TextField = styled(MuiTextField)(spacing);
const Alert = styled(MuiAlert)(spacing);

const AddDevice = () => {
  const navigate = useNavigate();

  return (
    <Grid minH="100vh" p={4} mt={4} backgroundColor="white">
      <Container maxW="container.lg" p={8} rounded="lg" shadow="lg">
        <Typography variant="h1" gutterBottom>
          Add Device
        </Typography>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: 50,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              maxWidth: 500,
              width: "100%",
            }}
          >
            <Typography variant="h6" paddingBottom={2}>
              Enter your FlipBit serial number
            </Typography>
            <Typography variant="body2" color="textSecondary" paddingBottom={3}>
              You can find this on the label on your device. Location and other
              details can be configured later.
            </Typography>
            <Formik
              initialValues={{
                serialNumber: "",
              }}
              validationSchema={Yup.object().shape({
                serialNumber: Yup.string().required(
                  "Serial number is required"
                ),
              })}
              onSubmit={async (
                values,
                { setErrors, setStatus, setSubmitting }
              ) => {
                try {
                  navigate("/devices/" + values.serialNumber);
                } catch (error) {
                  const message = error.message || "Something went wrong";
                  setStatus({ success: false });
                  setErrors({ submit: message });
                  setSubmitting(false);
                }
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values,
              }) => (
                <form noValidate onSubmit={handleSubmit}>
                  {errors.submit && (
                    <Alert mt={2} mb={1} severity="warning">
                      {errors.submit}
                    </Alert>
                  )}
                  <TextField
                    name="serialNumber"
                    label="Serial Number"
                    placeholder="e.g. flipbit_001"
                    value={values.serialNumber}
                    error={Boolean(touched.serialNumber && errors.serialNumber)}
                    fullWidth
                    helperText={touched.serialNumber && errors.serialNumber}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    my={3}
                  />
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting}
                  >
                    Continue
                  </Button>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </Container>
    </Grid>
  );
};

export default AddDevice;
